import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Segmented, Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyCargos } from 'api/cargos/use-get-many-cargos.ts';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params.ts';
import { useCargoFiltersStore } from 'shared/stores/use-cargo-filters.ts';
import { CargoCreateWithOrder } from 'components/cargos/cargo-create-with-order';
import { CargosFilter } from 'components/cargos/cargos-filter';
import { CargosList } from 'components/cargos/cargos-list';
import { CargosMapView } from 'components/cargos/cargos-map-view';
import { CargosSelectInfoWidget } from 'components/cargos/cargos-select-info-widget';
import { Pagination } from 'components/pagination';

export const CargosListPage: React.FC = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { t } = useTranslation();
  const [isMapView, setIsMapView] = useState(false);
  const { filters, search } = useCargoFiltersStore();
  const { data: cargos, isLoading, isPreviousData } = useGetManyCargos({ page, limit, filters, search });

  const toggleView = (value: string | number) => setIsMapView(value === 'map');

  usePageReset([filters, search]);

  const toggleBtn = (
    <Segmented
      options={[
        { label: t('common:table'), value: 'table' },
        { label: t('common:map'), value: 'map' },
      ]}
      onChange={toggleView}
    />
  );

  const header = (
    <PageHeader title={<CargosFilter />} extra={[toggleBtn, <CargoCreateWithOrder key='cargo-create-with-order' />]} />
  );

  return (
    <DefaultPageLayout header={header}>
      <Skeleton loading={isLoading}>
        {isMapView ? (
          <CargosMapView cargos={cargos?.data || []} pagination={cargos?.pagination} />
        ) : (
          <CargosList cargos={cargos?.data || []} isLoading={isPreviousData} />
        )}

        {!isMapView ? (
          <Pagination
            total={cargos?.pagination?.total}
            page={cargos?.pagination?.currentPage}
            limit={cargos?.pagination?.limit}
            onChange={handlePageChange}
          />
        ) : null}
        <CargosSelectInfoWidget />
      </Skeleton>
    </DefaultPageLayout>
  );
};
